export default "__VITE_ASSET__J$9ljW0s__";